import { reference } from "./_duck"
import * as types from "./types"

export const getReferenceRequest = reference.createAction(types.REFERENCE_GET_REQUEST)
export const getReferenceSuccess = reference.createAction(types.REFERENCE_GET_SUCCESS)
export const getReferenceFailure = reference.createAction(types.REFERENCE_GET_FAILURE)
